

document.addEventListener("DOMContentLoaded", function () {
  const faqTitle = document.querySelectorAll(".faq-list__title");
  const faqTitleArray = Array.from(faqTitle);
  const navContainer = document.querySelector(".faqs-list__mobile-nav-row");

  document.querySelector(".faq-list").style.marginTop = "40px";
  var firstIteration = true;

  const toKebabCase = (str) =>
    str &&
    str
      .match(
        /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
      )
      .map((x) => x.toLowerCase())
      .join("-");

  faqTitleArray.forEach(function (title) {
    const titleId = `id-${toKebabCase(title.textContent)}`;
    title.id = titleId;
    var selectorLink = document.createElement("a");
    selectorLink.classList.add("list-item");
    selectorLink.href = `#id-${toKebabCase(title.textContent)}`;

    var spanSphere = document.createElement("span");
    spanSphere.classList.add("faqs-lists__sphere");

    var titleList = document.createElement("p");
    titleList.textContent = title.textContent;
    titleList.classList.add("faqs-lists-index");
    titleList.setAttribute("id", `selector-${toKebabCase(title.textContent)}`);

    if (firstIteration == true) {
      titleList.classList.add("selected");
      firstIteration = false;
    }

    selectorLink.appendChild(titleList);
    selectorLink.appendChild(spanSphere);
    navContainer.appendChild(selectorLink);

    var mobileLink = document.createElement("a");
    mobileLink.href = `#id-${toKebabCase(title.textContent)}`;
  });
  const stickyHeader = document.querySelector(".section-header");
  const stickyHeaderHeight = stickyHeader ? stickyHeader.offsetHeight : 0;

  const targetElements = Array.from(
    document.querySelectorAll(".faq-list__header")
  );

  function scrollObserve() {
    targetElements.forEach((targetElement) => {
      const offsetTop = targetElement.offsetTop - stickyHeaderHeight - 10; // Adjusted for header
      if (window.pageYOffset >= offsetTop) {
        const targetId = `selector-${toKebabCase(targetElement.textContent)}`;
        removeAllSelected(indexSelector);
        const current = document.getElementById(targetId);
        if (current) current.classList.add("selected");
      }
    });
  }

  function noScoll() {
    return 0;
  }

  const allFAQsList = document.querySelectorAll(".faq-list");
  const allFAQsListArray = Array.from(allFAQsList);

  let allFAQsHeights = 0;

  allFAQsListArray.forEach(function (FAQsList) {
    allFAQsHeights = allFAQsHeights + FAQsList.offsetHeight;
  });

  document.documentElement.style.setProperty(
    "--all-faqs-heights",
    allFAQsHeights + "px"
  );

  const indexSelector = document.querySelectorAll(".list-item");
  indexSelector.forEach((item) => {
    item.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent default link jump

      const targetId = this.getAttribute("href").substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        const targetOffset =
          targetElement.getBoundingClientRect().top + window.pageYOffset;
        const adjustedOffset = targetOffset - stickyHeaderHeight;

        window.scrollTo({
          top: adjustedOffset,
          behavior: "smooth",
        });

        // Highlight selected item
        removeAllSelected(indexSelector);
        this.querySelector(".faqs-lists-index").classList.add("selected");
      }
    });
  });
  for (i = 0; i < indexSelector.length; i++) {
    const index = indexSelector[i];
    index.addEventListener("click", function () {
      removeAllSelected(indexSelector);

      this.querySelector(".faqs-lists-index").classList.add("selected");
    });
  }

  window.onscroll = function () {
    scrollObserve();
  };

  const faqIndexSelector = document.querySelectorAll(".list-item");
  const faqIndexSelectorArray = Array.from(faqIndexSelector);

  faqIndexSelectorArray.forEach((faqIndex) => {
    faqIndex.addEventListener("click", () => {
      window.onscroll = function () {
        noScoll();
      };
      setTimeout(() => {
        window.onscroll = function () {
          scrollObserve();
        };
      }, "500");
    });
  });

  function removeAllSelected(indexes) {
    for (i = 0; i < indexes.length; i++) {
      for (i = 0; i < indexes.length; i++) {
        indexes[i]
          .querySelector(".faqs-lists-index")
          .classList.remove("selected");
      }
    }
  }

$(".accordion-answer").hide();
$(".svg-icon-minus").hide();
$(".svg-icon-plus").show();

$(".accordion").off("click", ".question-with-icon").on("click", ".question-with-icon", function () {
  var $answer = $(this).siblings(".accordion-answer");
  var $plusIcon = $(this).find(".svg-icon-plus");
  var $minusIcon = $(this).find(".svg-icon-minus");

  // Detect current state BEFORE toggling
  var isVisible = $answer.is(":visible");

  // Toggle icons immediately
  if (isVisible) {
    $plusIcon.show();
    $minusIcon.hide();
  } else {
    $plusIcon.hide();
    $minusIcon.show();
  }

  // Then animate the answer
  $answer.slideToggle(300);
});



});
